import type { StatusOutput } from 'core/http/project/status/status.service';
import type { ProjectStatusOutput } from 'core/http/root/status.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StatusService } from 'core/http/root/status.service';
import { UserService } from 'core/http/root/user.service';
import { Observable } from 'rxjs';

@Injectable()
export class ProjectStatusesResolver {
  constructor(private statusService: StatusService) {
  }

  resolve(snapshot: ActivatedRouteSnapshot): Observable<ProjectStatusOutput[]> {
    return this.statusService.getProjectStatuses(snapshot.params.projectId);
  }
}

@Injectable()
export class AssignedStatusesResolver {
  constructor(private userService: UserService) {
  }

  resolve(snapshot: ActivatedRouteSnapshot): Observable<StatusOutput[]> {
    return this.userService.getAssignedStatuses(snapshot.params.managerId, snapshot.params.projectId);
  }
}
